import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const resultAttributes = [
  // General.
  'image_ratio_1_1_xxs',
  'image_ratio_1_1_xs',
  'image_ratio_1_1_sm',
  'image_ratio_1_1_md',

  'profile_image_ratio_1_1_xs',
  'profile_image_ratio_1_1_sm',
  'profile_image_ratio_1_1_md',

  'image_ratio_3_2_xxs',
  'image_ratio_3_2_xs',
  'image_ratio_3_2_sm',
  'image_ratio_3_2_md',

  'image_ratio_3_4_xxs',
  'image_ratio_3_4_xs',
  'image_ratio_3_4_sm',
  'image_ratio_3_4_md',

  'image_ratio_4_3_xxs',
  'image_ratio_4_3_xs',
  'image_ratio_4_3_sm',
  'image_ratio_4_3_md',

  'image_ratio_16_9_xxs',
  'image_ratio_16_9_xs',
  'image_ratio_16_9_sm',
  'image_ratio_16_9_md',

  'url',

  // Content.
  'nid',
  'entity_type',
  'page_title',
  'created',
  'content_type',
  'body',
  'body_summarized',
  'image_alt',
  'langcode',

  // Taxonomies
  'labels_name',

  // Article - Vacancy
  'publish_date',

  // Article
  'article_type_name',

  // Project
  'project_types_name',
  'project_status_name',

  // Vacancy
  'employment_types',
  'vacancy_function_name',
  'vacancy_locations_name',

  // Profile
  'profile_type',
  'profile_id',
  'first_name',
  'last_name',
  'profile_address',
  'profile_image_alt',
  'profile_functions_name',
  'profile_locations_name',
];

export const facetAttributes: Exclude<SearchkitWrapperProps['searchSettings']['facet_attributes'], undefined> = [
  {
    attribute: 'article_type_name',
    field: 'article_type_name',
    type: 'string',
  },
  {
    attribute: 'project_types_name',
    field: 'project_types_name',
    type: 'string',
  },
  {
    attribute: 'project_status_name',
    field: 'project_status_name',
    type: 'string',
  },
];
